import { LeaveCreateModal } from './LeaveCreateModal'
import { withLeaveCreateModal } from './withLeaveCreateModal'

const ConnectedLeaveCreateModal = withLeaveCreateModal(LeaveCreateModal)
export { ConnectedLeaveCreateModal as LeaveCreateModal }
